var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBounty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_16147",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H0V30H31V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_16147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H8.5C4.08172 0 0.5 3.58172 0.5 8V22C0.5 26.4183 4.08172 30 8.5 30H22.5C26.9183 30 30.5 26.4183 30.5 22V8C30.5 3.58172 26.9183 0 22.5 0Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.5H8.5C4.35786 0.5 1 3.85786 1 8V22C1 26.1421 4.35786 29.5 8.5 29.5H22.5C26.6421 29.5 30 26.1421 30 22V8C30 3.85786 26.6421 0.5 22.5 0.5Z",
    stroke: "white",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98389 14.6106L13.118 21.5107C14.5955 23.4964 17.4045 23.4964 18.882 21.5107L24.0161 14.6106C25.328 12.8475 25.328 10.3422 24.0161 8.57906C22.0957 5.9981 17.6571 6.76465 16 9.54855C14.3429 6.76465 9.90428 5.9981 7.9839 8.57906C6.67204 10.3422 6.67203 12.8475 7.98389 14.6106Z",
    fill: "white",
    fillOpacity: 0.05,
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounty);
export default __webpack_public_path__ + "static/media/bounty.316bae602df71837607e86e33cdbd3df.svg";
export { ForwardRef as ReactComponent };